// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"e59e5145","155":"d32aef01","513":"7e6c98c0","524":"e0ed0edb","592":"8b235bcb","632":"ad2a7fce","737":"6b41a773","944":"715a11a2"}[chunkId] + ".js";
};